import { ICreateColetaPrecoFornecedorUseCase } from "../../../presentation/useCases/create/create_coleta_preco_fornecedor_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CreateColetaPrecoFornecedorUseCase
 */

export class CreateColetaPrecoFornecedorUseCase implements ICreateColetaPrecoFornecedorUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async createColetaPrecoFornecedor(
    idColetaPreco: number,
    idRequisicaoCompra: number,
    idFornecedor: number,
    idsProdutosServicos: number[],
  ): Promise<number> {
    return await this.repository.createColetaPrecoFornecedor(
      idColetaPreco,
      idRequisicaoCompra,
      idFornecedor,
      idsProdutosServicos,
    );
  }
}
